import { memo } from 'react'
import TestExpirationEvent from './test-expiration.event'

const AppEvents = () => {
  const events = [TestExpirationEvent]

  return (
    <>
      {events.map((EventComponent, index) => (
        <EventComponent key={`event-${EventComponent.name}-${index}`} />
      ))}
    </>
  )
}

export default memo(AppEvents)
